// extracted by mini-css-extract-plugin
export default {"scanner":"Scanner_scanner__aTLPm","tips_and_manual":"Scanner_tips_and_manual__Jf+WK","tips":"Scanner_tips__--6XB"};